var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-table"},[_c('simple-table',{attrs:{"category":"indicators","columns":_vm.columns,"loading":_vm.loading,"error":_vm.error,"list":_vm.filteredList},on:{"rowClick":_vm.rowClick,"fetch":_vm.handleFetch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }